// extracted by mini-css-extract-plugin
export default {"share-button-container":"e_zOu","share-button":"stR8A","copy":"wzkwj","url":"rvM4Y"};